import { Button, Modal } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router';
import { ROUTES, TAB_KEYS } from '../../../../../../common/constants';
import useRouter from '../../../../../../common/useRouter';

const TableFieldUnsaveChangeModal = ({
  showPrompt,
  setShowPrompt,
  onSaveDraft,
}) => {
  const navigate = useNavigate();
  const {
    params: { projectId, registerId },
  } = useRouter();
  const handleCancel = () => {
    setShowPrompt(false);
  };
  const handleDiscard = () => {
    navigate(
      `${ROUTES?.PROJECTS}/${projectId}/${TAB_KEYS?.REGISTER}/${registerId}`,
    );
  };
  const handleSave = async () => {
    try {
      await onSaveDraft(true);
    } catch {
      // Silent error handling
    }
  };
  return (
    <Modal
      open={showPrompt}
      title="Leave this page"
      closable
      onCancel={handleCancel}
      maskClosable={false}
      centered
      footer={[
        <Button type="link" shape="round" key="discard" onClick={handleDiscard}>
          Discard
        </Button>,
        <Button
          key="save"
          shape="round"
          type="primary"
          onClick={handleSave}
          className="save-button"
        >
          Save as Draft
        </Button>,
      ]}
    >
      <p>
        You have unsaved changes. Would you like to save them as a draft before
        leaving?
      </p>
    </Modal>
  );
};

export default TableFieldUnsaveChangeModal;
